export const StepDirection = {
		NEXT: 1,
		BACK: -1
}
